import React from 'react';
import './ProductsDummy.css'


import { Rating } from '@mui/material';

const ProductDummy = () => {
    return (
        <div className='containerMain'>
            <div className='container2'>
                <div className='card'>
                    <h2></h2>
                    <div className="LeftItem " style={{ background: 'none' }}>
                        <p></p>
                        <Rating value={0} readOnly style={{ marginTop: '3px' }} />
                        <p></p>


                    </div>
                </div>
                <div className='card'>
                    <h2></h2>
                    <div className="LeftItem" style={{ background: 'none' }}>
                        <p></p>
                        <Rating value={0} readOnly style={{ marginTop: '3px' }} />
                        <p></p>


                    </div>
                </div>
                <div className='card LeftItem1'>
                    <h2></h2>
                    <div className="LeftItem" style={{ background: 'none' }}>
                        <p></p>
                        <Rating value={0} readOnly style={{ marginTop: '3px' }} />
                        <p></p>


                    </div>
                </div>
                <div className='card LeftItem2'>
                    <h2></h2>
                    <div className="LeftItem " style={{ background: 'none' }}>
                        <p></p>
                        <Rating value={0} readOnly style={{ marginTop: '3px' }} />
                        <p></p>


                    </div>
                </div>

            </div>
            <div className='container2'>
                <div className='card'>
                    <h2></h2>
                    <div className="LeftItem" style={{ background: 'none' }}>
                        <p></p>
                        <Rating value={0} readOnly style={{ marginTop: '3px' }} />
                        <p></p>


                    </div>
                </div>
                <div className='card'>
                    <h2></h2>
                    <div className="LeftItem" style={{ background: 'none' }}>
                        <p></p>
                        <Rating value={0} readOnly style={{ marginTop: '3px' }} />
                        <p></p>


                    </div>
                </div>
                <div className='card LeftItem1'>
                    <h2></h2>
                    <div className="LeftItem " style={{ background: 'none' }}>
                        <p></p>
                        <Rating value={0} readOnly style={{ marginTop: '3px' }} />
                        <p></p>


                    </div>
                </div>
                <div className='card LeftItem2'>
                    <h2></h2>
                    <div className="LeftItem" style={{ background: 'none' }}>
                        <p></p>
                        <Rating value={0} readOnly style={{ marginTop: '3px' }} />
                        <p></p>


                    </div>
                </div>

            </div>
        </div>
    )
}

export default ProductDummy